<template>
  <div>
    <ProgressBar />
    <PageHeading :default-heading="pageHeader" />
    <div class="pvd-container container-divider">
      <p>{{ pd_content.eligible_account_page.account_link_error }}</p>
      <p>
        <a :href="pd_content.eligible_account_page.all_account_link">
          {{ pd_content.eligible_account_page.open_new_account }}
        </a>{{ pd_content.eligible_account_page.today_get_started }}
      </p>
    </div>
    <div class="pvd-container container-divider">
      <p class="xsmall">
        <a :href="pd_content.eligible_account_page.fid_dot_com">{{ pd_content.eligible_account_page.go_to_fidelity }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import utility from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';

export default {
  name: 'EligibleAccountError',
  components: {
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  computed: {
    pageHeader() {
      const pageHeader = this.pd_content.page_header;
      if (pageHeader) {
        document.title = this.setTitle(pageHeader);
        return pageHeader;
      }
      return '';
    },
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    document.title = this.setTitle(this.pd_content.page_header);
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
};
</script>

<style scoped>

</style>
